import { IMSObject, IMSId } from './ims-object';

/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190402 by Jan Brunner
 *     all rights reserved.
 */

export class ProcessStep extends IMSObject {
  static fromDto(dto: ProcessStepDTO, databag?: any) {
    const obj = new this(
      {
        imsId: dto.id,
        secondaryId: dto.secondaryid,
        objRef: 'ims/ProcessStep'
      },
      dto.label,
      dto.name,
      dto.shortname
    );

    if (databag) {
      obj.databag = databag
    } else {
      obj.databag = dto;
    }
    return obj;
  }

  constructor(
    public readonly id: IMSId,
    label: string,
    public name: string,
    public shortname: string
  ) {
    super(id.imsId, id.secondaryId, label, id.objRef);
  }
}

export interface ProcessStepDTO {
  id: number;
  secondaryid: number;
  label: string;
  name: string;
  shortname: string;
}
